import SVGIconWrapper from "./SVGIconWrapper"

const IconInfo = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 80.8 80.8"
        iconClass={`icon--info ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <g>
            <path d="M40.4,0C18.1,0,0,18.1,0,40.4s18.1,40.4,40.4,40.4s40.4-18.1,40.4-40.4S62.6,0,40.4,0z M40.4,77.8 C19.8,77.8,3,61,3,40.4S19.8,3,40.4,3s37.4,16.8,37.4,37.4S61,77.8,40.4,77.8z" />
            <path d="M40.4,31.5c-0.8,0-1.5,0.7-1.5,1.5v24.1c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5V33 C41.9,32.2,41.2,31.5,40.4,31.5z" />
            <path d="M40.4,21c-1.4,0-2.6,1.2-2.6,2.6c0,1.4,1.2,2.6,2.6,2.6S43,25,43,23.6S41.8,21,40.4,21z" />
        </g>
    </SVGIconWrapper>
)

export default IconInfo